export default __webpack_public_path__ + "static/selfGuide-06c95b18a204d04404fd8e48e50cf17e.svg";